import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import Replanting from "../../components/replanting/Replanting";

function ReplantingPage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Replanting | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title={"Replanting"} t={t} />
      <Replanting />
    </>
  );
}

export default ReplantingPage;
